import Card from 'react-bootstrap/Card';

const CardMosquitera = (props) => {
  return (
    <Card style={{ width: 'auto' }} className="cardMosqui">
      
        <Card.Img variant="auto" src={props.img} className={props.clase} />
      
      <Card.Body className="bg-secondary">
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.text}</Card.Text>
      </Card.Body>
    </Card>

  );
};

export default CardMosquitera;


